import React from "react";

const VISAGE = `${import.meta.env.BASE_URL || "/static/react/"}epi/lumi-visage.webp`;

// Le visage de Lumi : bouton du haut, fenêtre et questions de Captures.
export default function EpiAvatar({ size = 30 }) {
  return <img alt="" className="epi-avatar" height={size} src={VISAGE} width={size} />;
}
